import request from '@/utils/request'

// 获取信息专栏列表
export async function api_getInfoPage(params) {
  return request({
    url: '/rest/info/page',
    method: 'get',
    params,
  })
}
// 修改info状态通过id
export async function api_putInfoStatus(params) {
  return request({
    url: '/rest/info/status',
    method: 'put',
    params,
  })
}
// 修改信息专栏
export async function api_putInfo(data) {
  return request({
    url: '/rest/info',
    method: 'put',
    data,
  })
}
// 新增信息专栏
export async function api_postInfo(data) {
  return request({
    url: '/rest/info',
    method: 'post',
    data,
  })
}
// 获取信息专栏详情
export async function api_getInfo(params) {
  return request({
    url: '/rest/info',
    method: 'get',
    params,
  })
}
// 删除信息专栏
export async function api_deleteInfo(params) {
  return request({
    url: '/rest/info',
    method: 'delete',
    params,
  })
}